import pluralize from 'pluralize';

export type GetWorkspaceUploadsHeaderParams = {
  completedCount: number;
  failedCount: number;
  inProgressCount: number;
  isPaused: boolean;
  progressingLabel: string;
};

export type WorkspaceUploadsHeader = {
  description: string | undefined;
  title: string;
};

export const getWorkspaceUploadsHeader = ({
  completedCount,
  failedCount,
  inProgressCount,
  isPaused,
  progressingLabel,
}: GetWorkspaceUploadsHeaderParams): WorkspaceUploadsHeader => {
  const hasFailedUploads = failedCount > 0;
  const hasInProgressUploads = inProgressCount > 0;
  const countedUploads = completedCount + inProgressCount;
  const title = hasInProgressUploads || hasFailedUploads ? pluralize('upload', countedUploads, true) : 'Uploads';

  if (!hasInProgressUploads) {
    return { description: undefined, title };
  }

  const remainingLabel = `${inProgressCount} remaining`;

  if (isPaused) {
    return { description: remainingLabel, title };
  }

  return { description: `${remainingLabel} · ${progressingLabel}`, title };
};
